var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.asta_squadre[_vm.user_uid]
    ? _c(
        "div",
        { staticClass: "chat-area-input" },
        [
          _c(
            "v-row",
            { attrs: { align: "center", "no-gutters": "" } },
            [
              _c(
                "v-col",
                [
                  _c("v-text-field", {
                    staticClass: "chat-input pa-2 ma-0",
                    attrs: { id: "messageInput", "hide-details": "" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.send()
                      },
                    },
                    model: {
                      value: _vm.messageInput,
                      callback: function ($$v) {
                        _vm.messageInput =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "messageInput",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { cols: "auto" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mr-2 white--text",
                      attrs: {
                        fab: "",
                        depressed: "",
                        small: "",
                        color: "primary",
                        disabled: _vm.messageInput.length == 0,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.send()
                        },
                      },
                    },
                    [_c("v-icon", { attrs: { small: "" } }, [_vm._v("send")])],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }